import { render, staticRenderFns } from "./KurccSitesPage.vue?vue&type=template&id=aa306b98&"
import script from "./KurccSitesPage.vue?vue&type=script&lang=js&"
export * from "./KurccSitesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports